import { useRouteError } from "react-router-dom";

export default function ErrorPage() {
    const error = useRouteError();
    console.error(error);

    return (
        <div id="error-page" className="flex justify-center items-center h-screen">
            <div className="text-center space-y-4">
                <h1>اوه</h1>
                <p>انگار اون چیزی که دنبالشید اینجا پیدا نمیشه</p>
                <p>
                    <span>{error.statusText || error.message}</span>
                </p>
            </div>
        </div>
    );
}